import { useEffect } from "react";
import { useSpring, animated } from "@react-spring/web";
import { Box, Button, Stack } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import ScreenContainer from "./ScreenContainer";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../../../Actions/appActions";

import imageCalling from "../../../../../../Assets/StoryOfficer/CALL_STACY.png";

import Message from "../../../../../Commons/Message";

interface ScreenProps {
  transition: number;
  screen: number;
  setStory: (value: Partial<StoryType>) => void;
  theme: Theme;
}

const Screen10 = (props: ScreenProps) => {
  const { transition, screen, setStory } = props;

  useEffect(() => {
    if (screen === 10 && transition === 2) setTimeout(() => setStory({ transition: transition + 1 }), 500);
    if (screen === 10 && transition > 2 && transition <= 4) setTimeout(() => setStory({ transition: transition + 1 }), 3000);
    if (screen === 10 && transition === 5) setTimeout(() => setStory({ animating: false }), 100);
    if (screen === 10 && transition === 6) setTimeout(() => setStory({ screen: screen + 1, transition: 2 }), 3000);

    return () => {};
  }, [transition, screen, setStory]);

  const propsMsgOne = useSpring({
    opacity: screen !== 10 || (screen === 10 && transition <= 2) ? 0 : 1,
    config: { duration: 600 },
  });

  const propsMsgTwo = useSpring({
    marginTop: "1.25em",
    opacity: screen !== 10 || (screen === 10 && transition <= 3) ? 0 : 1,
    config: { duration: 600 },
  });

  const propsBtn = useSpring({
    opacity: screen !== 10 || (screen === 10 && transition <= 4) ? 0 : 1,
    config: { duration: 600 },
  });

  const propsChat = useSpring({
    opacity: screen !== 10 || (screen === 10 && transition >= 6) ? 0 : 1,
    config: { duration: 600 },
  });

  const handleNextScreen = () => setStory({ transition: transition + 1, animating: true });

  return (
    <ScreenContainer>
      <Box sx={{ width: "53.38541667em" }}>
        <Stack direction={"row"} sx={{ justifyContent: "center", alignItems: "flex-start", marginTop: "2.60416667em" }}>
          <animated.div style={{ ...styles.people }}>
            <img src={imageCalling} alt="" style={styles.imageCalling} />
          </animated.div>
          <animated.div style={{ marginLeft: "7.08333333em", flex: 1, ...propsChat }}>
            <animated.div style={{ ...propsMsgOne }}>
              <Message name={"Stacy"} message={"Hey Trevor, what can I do for you?"} />
            </animated.div>
            <animated.div style={{ ...propsMsgTwo }}>
              <Message
                name={"Trevor"}
                message={"Hey Stacy the system has flagged an abandoned bag close to your location."}
                message2={"I’ve marked the location for you. Please investigate."}
              />
            </animated.div>
            <animated.div style={{ ...propsBtn }}>
              <Button sx={styles.btn} onClick={handleNextScreen} variant="contained" endIcon={<LocationOnIcon />}>
                Send Location
              </Button>
            </animated.div>
          </animated.div>
        </Stack>
      </Box>
    </ScreenContainer>
  );
};

const styles = {
  topBox: {
    textAlign: "center" as "center",
    width: "100%",
    marginTop: "2.60416667em",
  },
  text_1: {
    fontSize: "1.4583em",
    fontWeight: "bold",
  },
  boxText: {
    marginTop: "0.41666667em",
  },
  text_2: {
    fontSize: "1.25em",
  },
  people: {
    objectFit: "contain" as "contain",
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    display: "flex",
  },
  imageCalling: {
    width: "19.352vh",
  },
  btn: {
    marginTop: "2.1875em",
    textAlign: "left",
    justifycontent: "flex-start",
    display: "flex",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    transition: state.appReducer.story.transition,
    screen: state.appReducer.story.screen,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(Screen10, mapStateToProps, mapDispatchToProps);
